import React from 'react';
import PropTypes from 'prop-types';
import {Alert, Button} from 'react-bootstrap';
import ExtendedContentEditor from './ExtendedContentEditor';
import {isEmpty} from '../../../../utilities/validation';
import SweetAlert from 'sweetalert2-react';
import {escapeHTML} from '../../../../utilities/common';

const renderExtendedContentViewer = (htmlString, currentPageName) => {
    return (
        <div className="description">
            <h5>{`Extended content for page ${currentPageName}`}</h5>
            <br/>
            {(!isEmpty(htmlString) && htmlString !== '<p></p>') ? (
                    <div className="extended-content-viewer" dangerouslySetInnerHTML={{__html: escapeHTML(htmlString)}} />
                ):
                <Alert bsStyle="info">
                    <div className="info-text">
                        There is no content for this page...
                    </div>
                </Alert>
            }
        </div>
    );
};

class ExtendedContentSidebar extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            showEditorModal: false,
            submitting: false,
        };

        this.openPreviewExtendedContent = this.openPreviewExtendedContent.bind(this);
        this.closePreviewExtendedContent = this.closePreviewExtendedContent.bind(this);
        this.onCloseSuccessModal = this.onCloseSuccessModal.bind(this);
        this.disablePreviewButtonWhileSubmitting = this.disablePreviewButtonWhileSubmitting.bind(this);
        this.enablePreviewButtonAfterSubmitting = this.enablePreviewButtonAfterSubmitting.bind(this);
    }

    disablePreviewButtonWhileSubmitting(){
        this.setState({submitting: true});
    }

    enablePreviewButtonAfterSubmitting(){
        this.setState({submitting: false});
    }

    openPreviewExtendedContent () {
        if (this.props.extendedContentModified){
            this.setState({showEditorModal: true});
        }else{
            window.location.href= `${window.location.pathname}?preview`;
        }
    }

    closePreviewExtendedContent() {
        if(this.props.showEditorModalProps){
            this.props.handleUnsavedExtendedContent(false);
        }
        if(this.state.showEditorModal){
            this.setState({showEditorModal: false});
        }
    }

    onCloseSuccessModal() {
        if(this.props.showEditorModalProps){
            this.props.handleUnsavedExtendedContent(true);
        }
        if(this.state.showEditorModal){
            window.location.href= `${window.location.pathname}?preview`;
            this.setState({showEditorModal: false});
        }
    }

    render() {
        const {extendedContentStyle, contentJson, editing, currentPageId, pageNum, extendedContentId,extendedtextId,currentPageName,
            role, enableJREButtonsWhileSubmittingExtendedContent, disableJREButtonsWhileSubmittingExtendedContent} = this.props;

        const currentPageHtml = !isEmpty(contentJson) ? contentJson : '';  //naren contentJson[currentPageId]
        const {showEditorModal, submitting} = this.state;
        let {showEditorModalProps, previewing, extendedContentHtmlChanged} = this.props;

        if (editing === false) {
            return (
                <div className="extended-content-sidebar " style={extendedContentStyle}>
                    {renderExtendedContentViewer(currentPageHtml, currentPageName)}
                    {((role === 'teacher' || role === 'school_admin')) &&   // Naren  && previewing
                    <div className="teacher-btn-container">
                        <a
                            className="btn btn-warning p-t-10 p-b-10  btn-block"
                            href={`${window.location.pathname}?edit`}
                            title="Edit Extended Content">
                            Extend Content
                        </a>
                    </div>
                    }
                </div>
            );
        } else {
            return (
                <div className="extended-content-sidebar " style={extendedContentStyle}>
                    <SweetAlert
                        show={showEditorModal || showEditorModalProps}
                        text="Your unsaved changes will be lost!"
                        onConfirm={this.onCloseSuccessModal}
                        confirmButtonText="CONFIRM"
                        cancelButtonText="CANCEL"
                        focusConfirm={false}
                        type="warning"
                        title="Are You Sure?"
                        onCancel={this.closePreviewExtendedContent}
                        showCancelButton={true}
                        confirmButtonColor="#66BB55"
                        cancelButtonColor="#EF1E25"
                    />

                    <ExtendedContentEditor
                        currentPageHtml={currentPageHtml}
                        currentPageId={currentPageId}
                        currentPageName={currentPageName}
                        extendedContentId={extendedContentId}
                        extendedtextId={extendedtextId}
                        pageNum={pageNum}
                        extendedContentHtmlChanged={extendedContentHtmlChanged}
                        disablePreviewButtonWhileSubmitting={this.disablePreviewButtonWhileSubmitting}
                        enablePreviewButtonAfterSubmitting={this.enablePreviewButtonAfterSubmitting}
                        enableJREButtonsWhileSubmittingExtendedContent={enableJREButtonsWhileSubmittingExtendedContent}
                        disableJREButtonsWhileSubmittingExtendedContent={disableJREButtonsWhileSubmittingExtendedContent}
                    />
                    {((role === 'teacher' || role === 'school_admin') && editing) &&
                    <div className="teacher-btn-container">
                        <Button bsStyle="warning" block className="p-t-10 p-b-10" onClick={this.openPreviewExtendedContent} title="Preview Extended Content" disabled={submitting}>Preview Content</Button>
                    </div>
                    }
                </div>
            );
        }
    }
}


ExtendedContentSidebar.propTypes = {
    editing: PropTypes.bool.isRequired,
    contentJson: PropTypes.object.isRequired,
    currentPageId: PropTypes.string.isRequired,
    currentPageName: PropTypes.string.isRequired,
    extendedContentId: PropTypes.string.isRequired,
    extendedtextId:PropTypes.string.isRequired
};

export default ExtendedContentSidebar;



// WEBPACK FOOTER //
// ./src/js/components/app/jre/book/ExtendedContentSidebar.js